import React, { useMemo, useContext } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { usePaymentTermsContext } from 'contexts/CategoryInsightsKpi/PaymentTermsProvider';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const PaymentTermsExplore = () => {
	const { gridData } = usePaymentTermsContext();
	const { paymentTerms: days } = useContext(CategoryInsightsSettingsContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of vendors with DPO less than ${days} days.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default PaymentTermsExplore;
